module.exports = __webpack_public_path__ + "static/media/atm-card.7e7556d0.svg";